import * as types from "../../actionType";
import axios from "axios";
import { baseUrl } from "../../../Utiles/Helper";
import Cookies from "js-cookie";
import { client } from "../../AxiosInterceptor";
import { toast } from "../../../UIComponents/Toast";
const srStyleLoading = () => ({
  type: types.SR_STYLE_LOADING,
});
const srStyleSuccess = (data) => ({
  type: types.SR_STYLE_SUCCESS,
  payload: data
})
const srStyleFail = (error) => ({
  type: types.SR_STYLE_FAIL,
  payload: error
})
const getSrListLoading = () => ({
  type: types.GET_SR_LIST_LOADING
})
const getSrListSuccess = (data) => ({
  type: types.GET_SR_LIST_SUCCESS,
  payload: data
})
const getSrListFail = (error) => ({
  type: types.GET_SR_LIST_FAIL,
  payload: error
})
export const srExportLoading = () => ({
  type: types.SR_EXPORT_LOADING,
})
export const srExportSuccess = (data) => ({
  type: types.SR_EXPORT_SUCCESS,
  payload: data,
})
export const srExportFail = (error) => ({
  type: types.SR_EXPORT_FAIL,
  payload: error
})
export const srBrandName = (payload) => ({
  type: types.SR_BRANDS,
  payload,
});
export const resetSrData = (payload) => ({
  type: types.RESET_SR_DATA,
  payload,
});
export const resetSrSeasonFilter = (payload) => ({
  type: types.RESET_SR_SEASON_FILTER,
  payload,
});
export const selectUnselectSrTableRows = (payload) => ({
  type: types.SELECT_UNSELECT_SR_TABLE_ROWS,
  payload,
});
export const srExportArray = (payload) => ({
  type: types.SR_EXPORT_DATA,
  payload,
});
const srBulkSaveLoading = () => ({
  type: types.SR_BULK_SAVE_LOADING,
});
const srBulkSaveSuccess = (payload) => ({
  type: types.SR_BULK_SAVE_SUCCESS,
  payload,
});
const srBulkSaveFail = (error) => ({
  type: types.SR_BULK_SAVE_FAIL,
  payload: error,
});
const srSeasonSearchFilterLoading = () => ({
  type: types.SR_SEASON_SEARCH_FILTER_LOADING,
});
const srSeasonSearchFilterSuccess = (payload) => ({
  type: types.SR_SEASON_SEARCH_FILTER_SUCCESS,
  payload,
});
const srSeasonSearchFilterFail = (error) => ({
  type: types.SR_SEASON_SEARCH_FILTER_FAIL,
  payload: error,
});
const massSrSearchFilterLoading = () => ({
  type: types.MASS_SR_SEARCH_FILTER_LOADING,
});
const massSrSearchFilterSuccess = (payload) => ({
  type: types.MASS_SR_SEARCH_FILTER_SUCCESS,
  payload,
});
const massSrSearchFilterFail = (error) => ({
  type: types.MASS_SR_SEARCH_FILTER_FAIL,
  payload: error,
});
export const resetSrMassFilter = (payload) => ({
  type: types.RESET_SR_MASS_FILTER,
  payload,
});
const srDuplicateLoading = () => ({
  type: types.SR_DUPLICATE_LOADING,
});
const srDuplicateSuccess = (payload) => ({
  type: types.SR_DUPLICATE_SUCCESS,
  payload,
});
const srDuplicateFail = (error) => ({
  type: types.SR_DUPLICATE_FAIL,
  payload: error,
});
const srEditSrListLoading = () => ({
  type: types.SR_EDIT_SR_LIST_LOADING,
});
const srEditSrListSuccess = (payload) => ({
  type: types.SR_EDIT_SR_LIST_SUCCESS,
  payload,
});
const srEditSrListFail = (error) => ({
  type: types.SR_EDIT_SR_LIST_FAIL,
  payload: error,
});
const srLogsLoading = () => ({
  type: types.SR_LOGS_LOADING,
});
const srLogsSuccess = (payload) => ({
  type: types.SR_LOGS_SUCCESS,
  payload,
});
const srLogsFail = (error) => ({
  type: types.SR_LOGS_FAIL,
  payload: error,
});
const srReportGenerationLoading = () => ({
  type: types.SR_REPORT_GENERATION_LOADING,
});
const srReportGenerationSuccess = (payload) => ({
  type: types.SR_REPORT_GENERATION_SUCCESS,
  payload,
});
const srReportGenerationFail = (error) => ({
  type: types.SR_REPORT_GENERATION_FAIL,
  payload: error,
});
const srTemplateLoading = () => ({
  type: types.SR_TEMPLATE_LOADING,
});
const srTemplateSuccess = (payload) => ({
  type: types.SR_TEMPLATE_SUCCESS,
  payload,
});
const srTemplateFail = (error) => ({
  type: types.SR_TEMPLATE_FAIL,
  payload: error,
});
const getCurrentPagination = () => {
  const searchParams = new URLSearchParams(window.location.search);
  return {
    page: parseInt(searchParams.get("page")) || 1,
    pageSize: parseInt(searchParams.get("pageSize")) || 100,
  };
};

export const srStyleData = (style) => {
  let secure_token = Cookies.get("access_token");
  const formData = new FormData();
  formData.append("style_season", style);

  return function (dispatch) {
    const Config = {
      method: "POST",
      url: `/setup-ready`,
      data: formData,
      headers: {
        Authorization: `Bearer ${secure_token}`
      }
    };
    dispatch(srStyleLoading());
    return client(Config)
      .then((res) => {
        dispatch(srStyleSuccess(res?.data?.message));
        return res?.data?.message;
      })
      .catch((error) => {
        dispatch(srStyleFail(error))
      })
  }
}

export const duplicateSrStyleList = (user, id) => {
  let secure_token = Cookies.get("access_token");
  const formData = new FormData();
  formData.append("id", id);
  formData.append("user", user);

  return function (dispatch) {
    const Config = {
      method: "POST",
      url: `setup-ready-duplicate`,
      data: formData,
      headers: {
        Authorization: `Bearer ${secure_token}`
      }
    };
    dispatch(srDuplicateLoading());
    return client(Config)
      .then((res) => {
        dispatch(srDuplicateSuccess(res?.data?.message));
        return res;
      })
      .catch((error) => {
        dispatch(srDuplicateFail(error))
      })
  }
}

export const editSrStyleList = (user, id, product_line, state, grossCheckoutValue) => {
  let secure_token = Cookies.get("access_token");
  const formData = new FormData();
  formData.append("id", id);
  formData.append("product_line", product_line);
  formData.append("state", state);
  if (grossCheckoutValue !== undefined) {
    formData.append("gross_wholesale_price", grossCheckoutValue);
  }
  formData.append("user", user);

  return function (dispatch) {
    const Config = {
      method: "PUT",
      url: `setup-ready-edit`,
      data: formData,
      headers: {
        Authorization: `Bearer ${secure_token}`
      }
    };
    dispatch(srEditSrListLoading());
    client(Config)
      .then((res) => {
        dispatch(srEditSrListSuccess(res?.data?.message));
      })
      .catch((error) => {
        dispatch(srEditSrListFail(error))
      })
  }
}

export const getSrInitialList = (
  brand,
  style,
  factory,
  sale_sample,
  season,
  productLine,
  page,
  pageSize
) => {
  let secure_token = Cookies.get("access_token");
  const seasonArray = Array.isArray(season)
    ? season
    : season
      ? [season]
      : [];
  const seasonParams = seasonArray.length
    ? seasonArray.map(s => `season=${encodeURIComponent(s)}`).join("&")
    : `season=`;
  return function (dispatch) {
    const srListConfig = {
      method: "GET",
      url: `setup-ready-list?brand=${brand}&style=${style}&factory=${factory}&sale_sample=${sale_sample}&${seasonParams}&product_line=${productLine}&page=${page}&page_size=${pageSize}`,
      headers: {
        Authorization: `Bearer ${secure_token}`,
      },
    };
    dispatch(getSrListLoading());
    client(srListConfig)
      .then((resp) => {
        dispatch(getSrListSuccess(resp.data));
        localStorage.setItem("srApiData", resp.data);
      })
      .catch((error) => {
        dispatch(getSrListFail(error));
        if (error.response && error.response.status === 401) {
          toast.error(
            "Your session has expired. Please refresh the page to continue."
          );
        }
      });
  };
};

export const srSeasonSearchFilter = (
  brand,
  season,
  page,
  pageSize,
  sale_sample
) => {
  const secure_token = Cookies.get("access_token");
  const seasonQuery = Array.isArray(season) && season.length
    ? season.map(s => `season=${encodeURIComponent(s)}`).join("&")
    : `season=""`;
  return function (dispatch) {
    const srSeasonFilterConfig = {
      method: "GET",
      url: `setup-ready-season-search-filter?brand=${brand}&${seasonQuery}&page=${page}&page_size=${pageSize}&sale_sample=${sale_sample}`,
      headers: {
        Authorization: `Bearer ${secure_token}`,
      },
    };
    dispatch(srSeasonSearchFilterLoading());
    client(srSeasonFilterConfig)
      .then((resp) => {
        dispatch(srSeasonSearchFilterSuccess(resp.data));
        if (!resp.data?.results || resp.data.results.length === 0) {
          toast.error("Data not found");
        }
      })
      .catch((error) => {
        dispatch(srSeasonSearchFilterFail(error));
        if (error.response && error.response.status === 401) {
          toast.error(
            "Your session has expired. Please refresh the page to continue."
          );
        } else toast.error("Data not found");
      });
  };
};
export const massSrSearchFilter = (
  searchfilter,
  brandfilter,
  colorfilter,
  sizefilter,
  vendorfilter,
  sale_samplefilter,
  seasonfilter,
  page,
  pageSize
) => {
  const secure_token = Cookies.get("access_token");
  const searchArray = Array.isArray(searchfilter)
    ? searchfilter
    : searchfilter
      ? searchfilter.split(",").map((s) => s.trim())
      : [];
  const seasonArray = Array.isArray(seasonfilter)
    ? seasonfilter
    : seasonfilter
      ? seasonfilter.split(",").map((s) => s.trim())
      : [];

  return function (dispatch) {
    const srtMassFilterConfig = {
      method: "POST",
      url: `setup-ready-massfilter`,
      data: {
        searchfilter: searchArray, // ✅ ARRAY payload
        brandfilter,
        colorfilter,
        sizefilter,
        vendorfilter,
        sale_samplefilter,
        seasonfilter: seasonArray,
        page,
        pageSize
      },
      headers: {
        Authorization: `Bearer ${secure_token}`,
        'Content-Type': 'application/json',
      },
    };
    dispatch(massSrSearchFilterLoading());
    client(srtMassFilterConfig)
      .then((resp) => {
        dispatch(massSrSearchFilterSuccess(resp.data));
      })
      .catch((error) => {
        dispatch(massSrSearchFilterFail(error));
        if (error.response && error.response.status === 401) {
          toast.error(
            "Your session has expired. Please refresh the page to continue."
          );
        } else toast.error("Data not found");
      });
  };
};

export const getSrLogs = (
  id,
  style,
  factory,
  size,
  // season,
  color,
  // saleSample
) => {
  let secure_token = Cookies.get("access_token");
  return function (dispatch) {
    const srtLogConfig = {
      method: "GET",
      url: `setup-ready-logs?setup_ready_id=${id}&style=${style}&factory=${factory}&size=${size}&color_code=${color}`,
      headers: {
        Authorization: `Bearer ${secure_token}`,
      },
    };
    dispatch(srLogsLoading());
    client(srtLogConfig)
      .then((resp) => {
        dispatch(srLogsSuccess(resp.data));
      })
      .catch((error) => {
        dispatch(srLogsFail(error));
        if (error.response && error.response.status === 401) {
          toast.error(
            "Your session has expired. Please refresh the page to continue."
          );
        }
      });
  };
};

export const srExport = (payload) => {
  let secure_token = Cookies.get("access_token");

  return function (dispatch) {
    const srExportConfig = {
      method: "POST",
      url: "setup-ready-export",
      data: payload, // ✅ will now be { ids: [...] }
      headers: {
        Authorization: `Bearer ${secure_token}`,
        "Content-Type": "application/json",
      },
      responseType: "arraybuffer",
    };

    dispatch(srExportLoading());

    client(srExportConfig)
      .then((resp) => {
        dispatch(srExportSuccess(resp.data));

        const blob = new Blob([resp.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        saveAs(blob, "Setup Ready Export.xlsx");
      })
      .catch((error) => {
        dispatch(srExportFail(error));
      });
  };
};

export const srBulkSave = (data, brandNameFromApi) => {
  console.log("brandNameApi", data, brandNameFromApi);
  const srMassFilterData = JSON.parse(localStorage.getItem("srMassData"));
  const srData = JSON.parse(localStorage.getItem("srData"));
  const secure_token = Cookies.get("access_token");
  return function (dispatch) {
    const { page, pageSize } = getCurrentPagination();
    const srBulkSaveConfig = {
      method: "POST",
      url: `/setup-ready-bulk-save`,
      data,
      headers: {
        Authorization: `Bearer ${secure_token}`,
      },
    };
    dispatch(srBulkSaveLoading());
    client(srBulkSaveConfig)
      .then((resp) => {
        const skippedRecords = resp?.data?.skipped_records;

        if (Array.isArray(skippedRecords) && skippedRecords.length > 0) {
          const message = skippedRecords.join("\n");
          toast.error(message);
        } else {
          toast.success("Updated successfully");
        }

        dispatch(srBulkSaveSuccess(resp.data));

        dispatch(resetSrMassFilter([]));
        dispatch(resetSrSeasonFilter([]));
        if (srMassFilterData) {
          dispatch(
            massSrSearchFilter(
              srMassFilterData?.searchFilter || "",
              srMassFilterData?.brandFilter || "",
              srMassFilterData?.colorFilter || "",
              srMassFilterData?.sizeFilter || "",
              srMassFilterData?.vendorFilter || "",
              srMassFilterData?.sale_samplefilter || 0,
              srMassFilterData?.seasonFilter || "",
              page,
              pageSize
            )
          );
        } else {
          dispatch(getSrInitialList(
            brandNameFromApi,
            srData?.searchFilter || "",
            srData?.vendorFilter || "",
            0,
            srData?.seasonFilter || "",
            "",
            page || 1,
            pageSize || TOTAL_PER_PAGE
          ));
        }
        return resp.data
      })
      .catch((error) => {
        dispatch(srBulkSaveFail(error));
        if (error.response && error.response.status === 401) {
          toast.error(
            "Your session has expired. Please refresh the page to continue."
          );
        } else {
          toast.error(
            error?.response?.data?.error
              ? error?.response?.data?.error
              : "Could'nt Update Data"
          );
        }
      });
  };
};

export const srReportGeneration = (factory, fromDate, toDate, season, brand) => {
  let secure_token = Cookies.get("access_token");
  const seasonArray = Array.isArray(season)
    ? season
    : season
      ? [season]
      : [];

  const seasonParams = seasonArray.length
    ? seasonArray.map(s => `season=${encodeURIComponent(s)}`).join("&")
    : "";
  return function (dispatch) {
    const srReportGenConfig = {
      method: "GET",
      url: `setup-ready/report?factory=${factory}&from_date=${fromDate}&to_date=${toDate}&${seasonParams}&brand=${brand}`,
      factory,
      headers: {
        Authorization: `Bearer ${secure_token}`,
      },
      responseType: "arraybuffer",
    };
    dispatch(srReportGenerationLoading());
    client(srReportGenConfig)
      .then((resp) => {
        dispatch(srReportGenerationSuccess(resp.data));
        var blob = new Blob([resp.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        var fileName = "Setup Ready Report.xlsx";
        saveAs(blob, fileName);
      })
      .catch((error) => {
        dispatch(srReportGenerationFail(error));
        if (error.response && error.response.status === 401) {
          toast.error(
            "Your session has expired. Please refresh the page to continue."
          );
        } else toast.error("Data Not Found");
      });
  };
};

export const srTemplate = () => {
  let secure_token = Cookies.get("access_token");
  return function (dispatch) {
    const srReportGenConfig = {
      method: "GET",
      url: `setup-ready-template`,
      headers: {
        Authorization: `Bearer ${secure_token}`,
      },
      responseType: "arraybuffer",
    };
    dispatch(srTemplateLoading());
    client(srReportGenConfig)
      .then((resp) => {
        dispatch(srTemplateSuccess(resp.data));
        var blob = new Blob([resp.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        var fileName = "Setup Ready Template.xlsx";
        saveAs(blob, fileName);
      })
      .catch((error) => {
        dispatch(srTemplateFail(error));
        if (error.response && error.response.status === 401) {
          toast.error(
            "Your session has expired. Please refresh the page to continue."
          );
        } else toast.error("Data Not Found");
      });
  };
};